import { DeleteInitiativeNotifications } from './notifications';
import { InitiativeDetailIndex } from './detail/Index';
import { InitiativesSummaryIndex } from './summary/Index';
import { PARAMS } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

export const InitiativesIndex: React.FC = () => {
	const location = useLocation();

	return (
		<>
			<Routes>
				<Route
					element={ <InitiativesSummaryIndex /> }
					path='' />
				<Route
					element={ <InitiativeDetailIndex key={ location.pathname } /> }
					path={ PARAMS.ID } />
			</Routes>
			<DeleteInitiativeNotifications />
		</>
	);
};
